import { render, staticRenderFns } from "./shapeColorSelect.vue?vue&type=template&id=487b8d6a"
import script from "./shapeColorSelect.vue?vue&type=script&lang=js"
export * from "./shapeColorSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports